<template>
    <div class="flexbox-fullheight form-view">
        <Modal :config="projectNoteModalConfig" @accept="updateNote()">
            <template slot="header">
                rediger bemærkning
            </template>
            <template slot="content">
                <div class="form">
                    <div class="grid-x align-items">
                        <div class="large-1 medium-1 small-2 cell flexbox-center">
                            <icon class="small-svg" name="info"></icon>
                        </div>
                        <div class="auto cell border-bottom">
                            <div class="grid-x">
                                <div class="large-3 medium-3 small-5 cell flexbox-center-left">
                                    <label for="remark">Bemærkning</label>
                                </div>
                                <div class="auto cell">
                                    <textarea id="remark" class="full-width" v-model="note" rows="4"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </Modal>

        <Modal :config="projectHandlerModalConfig">
            <template slot="header">
                {{projectHandlerHeader}}
            </template>
        </Modal>

        <Modal :config="projectActivateModalConfig" @accept="activate()">
            <template slot="header">
                Er du sikker på, at du vil aktivere projektet?
            </template>
            <template slot="content">
                <div class="form">
                    <p class="text-center">Denne handling kan ikke fortrydes.</p>
                </div>
            </template>
        </Modal>
        
        <div v-if="!loading" class="project-container full-height">
            <!-- header -->
            <header class="project-container-header">
                <div class="grid-x">
                    <div class="large-1 medium-2 small-3 cell flexbox-start">
                        <router-link :to="{name: 'dashboard'}">
                            <icon class="arrow-left-circle-svg return-to-dashboard large-svg fill-white stroke-white" name="arrow-left-circle"></icon>
                        </router-link>
                    </div>
                    <div class="large-3 medium-7 small-6 cell flexbox-center-left">
                        <h3>
                            <span>{{project.projektStatusKode === 3 ? 'Opdatering af:' : 'Visning af:'}} {{project.projektNr}}</span>
                        </h3>
                        <div class="grid-x height-25">
                            <div class="auto cell truncate-fade-topbar">
                                <p>
                                    <b>Bemærkning:</b> {{project.beskrivelse ? project.beskrivelse : 'Ingen bemærkning'}}
                                </p>
                            </div>
                            <div v-if="project.projektStatusKode === 3" class="large-3 cell header-comment">
                                <a class="button button-header-with-icon icon-header" @click="openEditNoteModal(project.beskrivelse)">
                                    <icon class="small-svg fill-white" name="pencil"></icon>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div v-if="project.projektStatusKode !== 5 && project.projektStatusKode !== 6" class="large-3 medium-3 small-3 cell flexbox-start">
                        <div class="grid-x grid-margin-x flexbox-center">
                            <div class="large-6 medium-6 small-12 cell">
                                <a class="button button-big" @click="save()">Gem</a>
                            </div>
                            <div class="large-6 medium-6 small-12 cell">
                                <button :title="activateToggleDisableTitle" class="button button-big active-button" :class="{'disabled': activateToggleDisableTitle !== ''}" @click="activateToggleDisableTitle === '' && openActivateProjectModal()">Aktivér</button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <!-- content -->
            <main class="project-container-main">
                <div class="grid-x full-height">
                    <div class="large-1 medium-1 small-12 small-cell">
                        &nbsp;
                    </div>
                    <div class="large-7 medium-8 small-12 cell flex-column">
                        <!-- top -->
                        <div class="project-container-main-inner-top">
                            <h1>{{project.navn}}</h1>
                            <div class="project-container-main-inner-top-row">
                                <div class="project-container-main-inner-top-row-left">
                                    <h6 :class="{'padding-right-20': project.projektStatusKode !== 3}">Værdier</h6>
                                    <div v-if="project.projektStatusKode === 3" class="project-container-main-inner-top-row-left-item">
                                        <span class="align-text">Projekt</span>
                                        <div class="project-value-input">
                                            <currency-input :value="newProjectValue" @assign-new-asset-value="setNewProjectValue($event)"></currency-input>
                                        </div>
                                    </div>
                                    <div v-else class="project-container-main-inner-top-row-left-item">
                                        <span>Anskaffelsesværdi</span>
                                        <div class="project-assets-input">
                                            <span class="project-assets-input">{{project.projektVaerdi | convertToLocalStringDK}} kr.</span>
                                        </div>
                                    </div>
                                    <div class="project-container-main-inner-top-row-left-item">
                                        <span>Bogført værdi</span>
                                        <div class="project-assets-input">
                                            <span>{{totalAssetsValue | convertToLocalStringDK}} kr.</span>
                                        </div>
                                    </div>
                                    <div v-if="project.projektStatusKode === 3" class="project-container-main-inner-top-row-left-item">
                                        <span>Afgående</span>
                                        <div class="project-assets-input">
                                            <span>{{outgoingAssetsValue | convertToLocalStringDK}} kr.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="project-container-main-inner-top-row-right">
                                    <div v-if="project.projektStatusKode === 3" class="project-container-main-inner-top-row-right-left">
                                        <h6>Difference</h6>
                                        <div class="project-container-main-inner-top-row-right-left-difference">
                                            <p>{{difference | convertToLocalStringDK}}</p><span>&nbsp;kr.</span>
                                        </div>
                                    </div>
                                    <div v-if="project.projektStatusKode === 3 && selectedRegnskab.systemKode !== 4" class="project-container-main-inner-top-row-right-right">
                                        <a class="button button-secondary no-icon" @click="distributeValues()">
                                            Fordel værdi
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- balance -->
                        <div class="project-container-main-inner-balance">
                            <div class="project-container-main-inner-balance-balance">
                                <span>Balance:</span>
                                <select v-model="selectedBalanceId" id="select-template">
                                    <option value="" disabled="disabled">Vælg balance i listen</option>
                                    <option v-for="balance in regnskabSetting" :selected="balance.beskrivelse" v-bind:key="balance.id" :value="balance.id">
                                        {{balance.beskrivelse}}
                                    </option>
                                </select>
                            </div>
                            <div v-if="project.projektStatusKode === 3 && selectedRegnskab.systemKode !== 4" class="project-container-main-inner-balance-switch">
                                <switches v-model="switchEnabled" theme="custom" type-bold="false" color="blue" style="margin-right: 10px;"></switches>
                                <span>Se priser & fordeling</span>
                            </div>
                            <div v-if="project.projektStatusKode === 3" class="project-container-main-inner-balance-date">
                                <date-picker
                                    v-model="AfskrivningsStartDato"    
                                    id="datepicker"
                                    name="Datepicker"
                                    language="da"
                                    full-month-name
                                    :monday-first="true"
                                    class="full-width datepicker-filter"
                                    format="d. MMMM yyyy"
                                    placeholder="Vælg dato">
                                    <icon class="calendar small-svg" name="calendar"></icon>
                                </date-picker>
                                <a @click="setDateAssets()" class="button button-secondary no-icon button-filter">
                                    Sæt dato
                                </a>
                            </div>
                        </div>

                        <!-- export -->
                        <div class="project-container-main-inner-export">
                            <div>
                                <span>
                                    <b>{{project.importAktivs ? project.importAktivs.length : project.aktivs.length}} aktiver</b>
                                </span>
                            </div>
                            <div>
                                <a @click="exportAsExcel()" class="button button-simplified">
                                    <icon class="small-svg fill-primary" name="export"></icon>
                                    Eksportér
                                </a>
                            </div>
                        </div>

                        <!-- list -->
                        <div class="project-container-main-inner-list">
                            <!-- asset list -->
                            <div v-if="!switchEnabled" style="margin-right: 10px;">
                                <div v-if="sortedAssets && sortedAssets.length > 0" class="grid-x list-sort">
                                    <div v-if="project.projektStatusKode === 3" class="large-1 cell"></div>
                                    <div class="cell large-3 item flexbox" @click="sort('kategoriNavn')" :class="[{selected: currentSort === 'kategoriNavn'}, project.projektStatusKode === 3 ? 'large-3' : 'large-5']">
                                        <span>Navn</span>
                                        <div>
                                            <icon v-if="currentSort === 'kategoriNavn'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'kategoriNavn'}" name="keyboard_arrow_sort"></icon>
                                        </div>
                                    </div>
                                    <div class="large-2 cell item flexbox flexbox-center" @click="sort('restVaerdi')" :class="{selected: currentSort === 'restVaerdi', 'flexbox-center': project.projektStatusKode === 3}">
                                        <span>Værdi</span>
                                        <div>
                                            <icon v-if="currentSort === 'restVaerdi'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'restVaerdi'}" name="keyboard_arrow_sort"></icon>
                                        </div>
                                    </div>
                                    <div class="large-2 cell item flexbox flexbox-center" @click="sort('levetid')" :class="{selected: currentSort === 'levetid'}">
                                        <span>Restlevetid</span>
                                        <div>
                                            <icon v-if="currentSort === 'levetid'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'levetid'}" name="keyboard_arrow_sort"></icon>
                                        </div>
                                    </div>
                                    <div class="large-2 cell item flexbox flexbox-center" @click="sort('afskrivningStart')" :class="{'selected': currentSort === 'afskrivningStart'}">
                                        <span>Afskrivningsstartdato</span>
                                        <div>
                                            <icon v-if="currentSort === 'afskrivningStart'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'afskrivningStart'}" name="keyboard_arrow_sort"></icon>
                                        </div>
                                    </div>
                                     <div v-if="project.projektStatusKode === 3" class="large-1 cell item flexbox flexbox-center" @click="sort('getvalue')" :class="{'selected': currentSort === 'getvalue'}">
                                        <span>Giv værdi</span>
                                        <div>
                                            <icon v-if="currentSort === 'getvalue'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'getvalue'}" name="keyboard_arrow_sort"></icon>
                                        </div>
                                    </div>
                                    <div class="large-1 cell small-box"></div>
                                </div>

                                <transition-group name="list" tag="div">
                                    <div v-if="sortedAssets && sortedAssets.length > 0" v-for="asset in sortedAssets" :key="asset.id" class="grid-x" :class="[project.projektStatusKode === 3 ? 'list' : 'list-row']">
                                        <div v-if="project.projektStatusKode === 3" class="cell large-1 flexbox-center">
                                            <div @click="goToAssetDetailIcon(asset)" class="icon-button">
                                                <icon class="medium-svg fill-selected-dark-gray" :title='asset.importAktivTypeKode | translateImportAktivType' :name="asset | translateImportAktivTypeToIcon"></icon>
                                            </div>
                                        </div>
                                        <div @click="goToAssetDetail(asset)" class="cell item" :class="[project.projektStatusKode === 3 ? 'truncate-fade-gray large-3' : 'truncate-fade large-5']">
                                            <!-- :style="{ backgroundColor: asset.baggrundsfarve }" -->
                                            <span :title="asset.kategoriNavn ? asset.kategoriNavn : asset.aktivKategoriNavn" :style="getbackgroundcolor(asset.baggrundsfarve)">{{ asset.kategoriNavn ? asset.kategoriNavn : asset.aktivKategoriNavn }}</span>
                                            <span :title="asset.beskrivelse">{{ asset.beskrivelse }}</span>
                                            
                                        </div>
                                        <div v-if="project.projektStatusKode === 3" class="large-2 cell project-value-input input-list flexbox-align-items">
                                            <currency-input v-if="project.projektStatusKode === 3" :value="asset.restVaerdi" :disabled="checkImportType(asset)" @assign-new-asset-value="setNewAssetValues(asset, $event)"></currency-input>
                                        </div>
                                        <div v-else @click="goToAssetDetail(asset)" class="large-2 cell item flexbox-center">
                                            <span>{{getAssetValue(asset, 'Vaerdi')| convertToLocalStringDK}} kr.</span>
                                        </div>
                                        <div @click="goToAssetDetail(asset)" class="large-2 cell flexbox-center" :class="{'truncate-fade-gray': project.projektStatusKode === 3, 'truncate-fade-blue': project.projektStatusKode !== 3}">
                                            <span class="text-semi-bold">{{ getAssetValue(asset, 'levetid') ? getAssetValue(asset, 'levetid') : '0' }}</span>
                                        </div>
                                        <div v-if="project.projektStatusKode === 3" @click="goToAssetDetail(asset)" class="cell large-2 item flexbox-align-items" style="justify-content: center;">
                                            <span class="text-center">{{asset.afskrivningStart | formatDateShort}}</span>
                                        </div>
                                        <div v-else @click="goToAssetDetail(asset)" class="large-2 cell item flexbox-center" :class="{'truncate-fade-gray': project.projektStatusKode === 3, 'flexbox-center': project.projektStatusKode === 3, 'truncate-fade': project.projektStatusKode !== 3}" :title="asset.AfskrivningsStartDato">
                                            <span>{{ getAssetValue(asset, 'afgangsdato') || getAssetValue(asset, 'afskrivningsStartDato') | formatDateShort}}</span>
                                        </div>
                                        <div v-if="project.projektStatusKode === 3" @click="goToAssetDetail(asset)" class="cell large-1 item flexbox-align-items" style="justify-content: center;">
                                            <input v-model="asset.getvalue" type="checkbox" :disabled="checkImportType(asset)">
                                        </div>                                        
                                        <div class="large-1 cell small-box flexbox-center" @click="setLocationWkt(asset)" :class="{'button-highlight': asset.wkt}" style="height: 35px;">
                                            <icon v-if="asset.wkt" class="small-svg fill-primary-no-stroke" name="location"></icon>
                                        </div>
                                    </div>
                                </transition-group>

                                <div v-if="sortedAssets && sortedAssets.length === 0" class="list-counter grid-x">
                                    <div class="no-result full-width">
                                        <div class="large-12 cell">
                                            <span>Ingen aktiver, prøv med en anden:</span>
                                            <ul>
                                                <li>Balance</li>
                                            </ul>
                                        </div>
                                        <div class="grid-x">
                                            <div class="large-12 no-result-img cell"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- distribution list -->
                            <div v-if="switchEnabled" style="margin-right: 10px;">
                                <div class="grid-x list-sort non-sortable">
                                    <div class="large-4 cell item flexbox">
                                        <span>Kategori</span>
                                    </div>    
                                    <div class="auto cell item flexbox">
                                        <span>Pris pr. enhed</span>
                                    </div>
                                    <div class="auto cell item flexbox">
                                        <span title="Forskellen på gennemsnitsprisen og prisen pr. enhed angivet i %">Afvigelse</span>
                                    </div>
                                    <div class="auto cell item flexbox">
                                        <span title="Forskel på gennemsnitspris og prisen pr. enhed ganget med antallet af meter eller antal">Prisforskel</span>
                                    </div>
                                    <div class="auto cell item flexbox">
                                        <span title="Gennemsnitspris i kategorien på baggrund af tilgængelige data inden for de sidste 5 år">Gennemsnitspris</span>
                                    </div>
                                </div>

                                <div v-for="(item, index) in calculatedDistributionList" :key="index" class="list grid-x">
                                    <div class="large-4 cell flexbox-center-left truncate-fade" :title="item.Navn">
                                        <span class="normal-font">{{item.Navn}}</span>
                                    </div>
                                    <div class="auto cell flexbox-align-items">
                                        <span class="normal-font">{{item.EnhedsPris | convertToLocalStringDK}} kr.</span>
                                    </div>
                                    <div class="auto cell flexbox-align-items">
                                        <span class="normal-font">
                                            <b>{{item.Afvigelse}}%</b>
                                            <span class="vertical-icon">
                                                <icon class="small-svg" :class="{'fill-green': item.Afvigelse < 100 || item.Afvigelse === 100, 'fill-red': item.Afvigelse > 100 }" :name="deviation(item)"></icon>
                                            </span>
                                        </span>
                                    </div>
                                    <div class="auto cell flexbox-align-items">
                                        <span class="normal-font">{{item.PrisForskel | convertToLocalStringDK}} kr.</span>
                                    </div>
                                    <div class="auto cell flexbox-align-items">
                                        <span class="normal-font">{{item.GennemsnitsPris | convertToLocalStringDK}} kr.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="auto cell">
                        <nmap :config="mapConfig" @mounted="mapLoaded"/>
                    </div>
                </div>
            </main>
        </div>
        <div v-else class="loading-div">
            <h1 class="loading-header">Henter projekt...</h1>
        </div>
        <div v-if="!loading" class="flexbox-full-height form-view">
            <project-slider :sliderOpen="sliderOpen" :selectedAsset="selectedAsset" @toggleSlider="toggleSlider"></project-slider>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Switches from 'vue-switches'
import Datepicker from 'vuejs-datepicker'
import axios from '@/store/api.js'
import Modal from '@/components/modal/modal.vue'
import { ModalConfig } from '@/components/modal/modal.js'
import projectSlider from '@/components/page/project/project-slider.vue'
import currencyInput from '@/components/currency-input/currency-input.vue'
import { NMap, NMapConfig, NMapUtils, NMapStyle, NMapStyleCircle, NMapLayerControl, NMapLayerEsriWorldImagery, NMapLayerOpenStreetMap, NMapLayerVector, NMapBoundingBox, NMapCoordinates, NMapFeature } from 'ncomponents-map'

export default {
    name: 'projectid',
    components: {
        Switches,
        'date-picker': Datepicker,
        Modal,
        'currency-input': currencyInput,
        'project-slider': projectSlider,
        nmap: NMap
    },
    data () {
        return {
            projectHandlerModalConfig: {},
            projectNoteModalConfig: {},
            projectActivateModalConfig: {},
            projectHandlerHeader: '',
            loading: false,
            project: {},
            priceMeter: [],
            note: '',
            newProjectValue: 0,
            totalAssetsValue: 0,
            outgoingAssetsValue: 0,
            // filters
            AfskrivningsStartDato: null,
            switchEnabled: false,
            // list
            assets: [],
            currentSort: 'sortering',
            currentSortDir: 'desc',
            // slider
            sliderOpen: false,
            selectedAsset: null,
            // map
            mapConfig: null,
            mapLayers: {
                highlightLayer: null,
                featureLayer: null
            }
        }
    },
    computed: {
        ...mapGetters({
            regnskabSetting: 'getRegnskabSetting',
            selectedRegnskab: 'getSelectedRegnskab'
        }),
        selectedBalanceId: {
            get () {
                return this.$store.getters.getSelectedBalance.id
            },
            async set (value) {
                const selectedRegnskab = this.regnskabSetting.find(r => r.id === value)
                if (selectedRegnskab) {
                    this.$store.state.global.selectedBalance = selectedRegnskab
                }

                try {
                    const showModalConfig = true
                    if (this.project.projektStatusKode > 3) {
                        await this.getProject(showModalConfig)
                    } else {
                        await this.getPriceMeter(selectedRegnskab.aarsbalance.id, showModalConfig)
                    }
                } catch (err) {
                    console.log('error getting priceMeter', err)
                }
            }
        },
        difference () {
            let result = 0 - this.totalAssetsValue
            if (this.newProjectValue) {
                // Check if illegal number or string
                result = this.newProjectValue - this.totalAssetsValue
                if (result > -0.01 && result < 0.01) {
                    result = 0
                }
            }
            return result
        },
        sortedAssets () {
            return this.assets.sort((a, b) => {
                let modifier = 1
                if (this.currentSortDir === 'desc') {
                    modifier = -1
                }

                if (this.currentSort === 'kategoriNavn') {
                    if (!a.kategoriNavn && !b.kategoriNavn) {
                        if (a.aktivKategoriNavn < b.aktivKategoriNavn || a.aktivKategoriNavn === null) {
                            return -1 * modifier
                        }
                        if (a.aktivKategoriNavn > b.aktivKategoriNavn || b.aktivKategoriNavn === null) {
                            return 1 * modifier
                        }
                        return 0
                    }
                }

                if (this.project.projektStatusKode > 3) {
                    let sortString = null

                    if (this.currentSort === 'afskrivningStart') {
                        if (this.project.projektStatusKode > 4) {
                            sortString = 'iDriftTagningsDato'
                        } else {
                            sortString = 'tilgangsdato'
                        }
                    }
                    if (this.currentSort === 'levetid') {
                        sortString = 'restLevetid'
                    }

                    if (!sortString) {
                        sortString = this.currentSort
                    }

                    if (a[sortString] < b[sortString] || a[sortString] === null) {
                        return -1 * modifier
                    }
                    if (a[sortString] > b[sortString] || b[sortString] === null) {
                        return 1 * modifier
                    }

                    return 0
                } else {
                    console.log('sortering', this.currentSort)
                    if (a[this.currentSort] < b[this.currentSort] || a[this.currentSort] === null) {
                        return -1 * modifier
                    }
                    if (a[this.currentSort] > b[this.currentSort] || b[this.currentSort] === null) {
                        return 1 * modifier
                    }

                    return 0
                }
            })
        },
        calculatedDistributionList () {
            const selectedBalance = this.regnskabSetting.find(r => r.id === this.selectedBalanceId)

            let filteredList = this.assets.filter(asset => {
                if (asset.afgang === 1) {
                    return false
                } else if (asset.samle === 1 || asset.erstat === 1 || asset.stikErstat === 1) {
                    const aktivKategori = selectedBalance.aktivKategori.find(kategori => kategori.id === asset.aktivKategoriId)
                    if (aktivKategori.foring === 0) {
                        return false
                    }
                }
                return asset
            })

            let groupList = []

            filteredList.forEach(asset => {
                let object = {}
                let importInfo = asset.importInfo.find(info => info.BalanceId.toLowerCase() === this.selectedBalanceId.toLowerCase())
                let foundGroup = groupList.find(group => group.Id === asset.aktivKategoriId)
                let pricePrMeter = this.priceMeter.find(price => price.aktivKategoriId === asset.aktivKategoriId)
                if (foundGroup) {
                    foundGroup.AntalEnheder += asset.meangde
                    foundGroup.TotalPris += importInfo.Vaerdi
                    foundGroup.Enhedspris = foundGroup.TotalPris / foundGroup.AntalEnheder
                } else {
                    const aktivKategori = selectedBalance.aktivKategori.find(kategori => kategori.id === asset.aktivKategoriId)
                    object.Id = asset.aktivKategoriId
                    object.Navn = aktivKategori.navn
                    object.AntalEnheder = asset.meangde
                    object.TotalPris = importInfo.Vaerdi
                    object.EnhedsPris = importInfo.Vaerdi / asset.meangde

                    if (pricePrMeter) {
                        object.GennemsnitsMaengde = pricePrMeter.totalMeangde
                        object.GennemsnitsPris = pricePrMeter.prisPrEnhed
                    } else {
                        object.GennemsnitsMeangde = 0
                        object.GennemsnitsPris = 0
                    }

                    groupList.push(object)
                }
            })

            groupList.forEach(group => {
                group.PrisForskel = (group.TotalPris - (group.GennemsnitsPris * group.AntalEnheder))
                let totalPris = group.TotalPris
                if (totalPris === 0) {
                    group.Afvigelse = 0
                } else {
                    // SKAL FIXES
                    // bf7e050e-ccaf-411d-83c4-be78076039ce => gennemsnitsPris er 0 = calc bliver Infinity
                    let calc = (group.EnhedsPris - group.GennemsnitsPris) / group.GennemsnitsPris * 100
                    let calcInt = parseInt(calc)
                    group.Afvigelse = Math.abs(calcInt)
                }
            })
            return groupList
        },
        activateToggleDisableTitle () {
            const selectedBalance = this.regnskabSetting.find(r => r.id === this.selectedBalanceId)

            if (this.difference !== 0) {
                return 'Projekt sum passer ikke med samlet værdi for aktiver'
            } else if (!this.sortedAssets.some(a => new Date(a.afskrivningStart).getFullYear() === selectedBalance.aarsbalance.aar)) {
                return 'Afskrivningsstartdato for alle aktiver skal ligge i indeværende regnskabsår'
            } else {
                return ''
            }
        }
    },
    methods: {
        toggleSlider (boolean, asset) {
            this.sliderOpen = boolean
            this.selectedAsset = asset
        },
        getbackgroundcolor (value) {
            return 'background-color:' + value
        },
        openEditNoteModal (note) {
            this.note = JSON.parse(JSON.stringify(note))
            this.projectNoteModalConfig.open()
        },
        openActivateProjectModal () {
            this.projectActivateModalConfig.open()
        },
        updateNote () {
            this.project.beskrivelse = this.note
        },
        distributeValues () {
            this.newProjectValue = window.numeral(this.newProjectValue).value()
            const selectedBalance = this.regnskabSetting.find(r => r.id === this.selectedBalanceId)

            let filteredList = this.assets.filter(asset => {
                if (asset.afgang) {
                    return false
                } else if (!asset.getvalue) {
                    return false
                } else if (asset.samle === 1 || asset.erstat === 1 || asset.stikErstat === 1) {
                    const aktivKategori = selectedBalance.aktivKategori.find(kategori => kategori.id === asset.aktivKategoriId)
                    if (aktivKategori.foring === 0) {
                        return false
                    }
                }
                return asset
            })

            let newValue = `${this.$options.filters.convertToNumber(this.newProjectValue)}`
            let totalStandardVaerdi = 0
            if (!newValue || isNaN(newValue)) {
                this.newProjectValue = 0
                newValue = 0
            }

            filteredList.forEach(list => {
                const aktivKategori = selectedBalance.aktivKategori.find(kategori => kategori.id === list.aktivKategoriId)
                if (list.meangde <= 0) {
                    list.standardVaerdi = aktivKategori.standardVaerdi * 1
                } else {
                    list.standardVaerdi = aktivKategori.standardVaerdi * list.meangde
                }
                totalStandardVaerdi += list.standardVaerdi
            })

            let factor = newValue / totalStandardVaerdi

            filteredList.forEach(list => {
                let vaerdi = list.standardVaerdi * factor
                list.importInfo.forEach(info => {
                    info.Vaerdi = vaerdi
                })
                list.restVaerdi = vaerdi
                list.NewValue = vaerdi
            })

            this.updateTotelAssetsValue()
        },
        updateTotelAssetsValue () {
            let totalValue = 0
            this.assets.forEach(asset => {
                if (!asset.afgang) {
                    totalValue += asset.restVaerdi
                }
            })
            this.totalAssetsValue = totalValue
        },
        setDateAssets () {
            const formatted = window.moment(this.AfskrivningsStartDato).format().substring(0, 19)
            this.assets.forEach(asset => {
                asset.importInfo.forEach(info => {
                    this.$set(info, 'AfskrivningStart', formatted)
                })
                this.$set(asset, 'afskrivningStart', formatted)
            })
        },
        sort (s) {
            if (s === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
            }
            this.currentSort = s
        },
        checkImportType (asset) {
            if (this.project.projektStatusKode === 3) {
                if (asset.afgang === 1) {
                    return true
                } else if (asset.samle === 1 || asset.erstat === 1 || asset.stikErstat === 1) {
                    const selectedBalance = this.regnskabSetting.find(r => r.id === this.selectedBalanceId)
                    const aktivKategori = selectedBalance.aktivKategori.find(kategori => kategori.id === asset.aktivKategoriId)
                    if (aktivKategori.foring === 0) {
                        return true
                    }
                }
            }

            return false
        },
        getAssetValue (asset, string) {
            if (this.project.projektStatusKode > 4) {
                if (string === 'afskrivningsStartDato') {
                    return asset['iDriftTagningsDato']
                }
                if (string === 'Vaerdi') {
                    return asset['restVaerdi']
                }
                if (string === 'levetid') {
                    return asset['restLevetid']
                }
                return asset[string]
            } else {
                const foundImportInfo = asset.importInfo.find(i => i.BalanceId.toLowerCase() === this.selectedBalanceId)
                if (foundImportInfo) {
                    if (this.project.projektStatusKode === 3) {
                        const capitalizedString = string.charAt(0).toUpperCase() + string.slice(1)
                        return foundImportInfo[capitalizedString]
                    } else {
                        return foundImportInfo[string]
                    }
                }
            }
        },
        setNewProjectValue (newvalue) {
            this.newProjectValue = newvalue
        },
        setNewAssetValues (asset, newvalue) {
            asset.restVaerdi = newvalue
            let alleVaerdier = []
            this.assets.forEach(asset => {
                if (asset.restVaerdi !== null || asset.restVaerdi !== undefined) {
                    // Check if illegal number or string
                    let newval = asset.restVaerdi
                    // newval = `${this.$options.filters.convertToNumber(newval)}`
                    // Still illegal number after being converted? Like 'dsdsds'
                    if (!isNaN(newval)) {
                        // filter listen af newValue, så det kun er bestemte værdier, som kommer med
                        if (asset.afgang === 1) {
                            // ignore
                        } else if (asset.samle === 1 || asset.erstat === 1 || asset.stikErstat === 1) {
                            const selectedBalance = this.regnskabSetting.find(r => r.id === this.selectedBalanceId)
                            const aktivKategori = selectedBalance.aktivKategori.find(kategori => kategori.id === asset.aktivKategoriId)
                            if (aktivKategori.foring === 0) {
                                // ignore
                            }
                        } else {
                            alleVaerdier.push(newval)
                        }
                    }
                }
            })
            this.totalAssetsValue = alleVaerdier.reduce((a, b) => parseInt(a) + parseInt(b), 0)
        },
        setLocationWkt (asset) {
            this.mapLayers.highlightLayer.clear()
            if (asset.feature) {
                this.mapConfig.fit(asset.feature, {maxZoom: 20})
                this.mapLayers.highlightLayer.addFeature(new NMapFeature({
                    sourceType: 'wktFeature',
                    source: asset.wkt,
                    projection: 'EPSG:25832',
                    style: asset.mapStyle === 'spild_broend'
                        ? new NMapStyleCircle({
                            fillOpacity: 0,
                            strokeColor: 'orange',
                            strokeOpacity: 0.6,
                            strokeWidth: 9
                        })
                        : new NMapStyle({
                            strokeColor: 'orange',
                            strokeOpacity: 0.6,
                            strokeWidth: 9
                        })
                }))

                this.mapLayers.highlightLayer.addFeature(new NMapFeature({
                    sourceType: 'wktGeometry',
                    source: asset.wkt,
                    projection: 'EPSG:25832',
                    style: this.getFeatureStyle(asset)
                }))
            }
        },
        goToAssetDetail (asset) {
            if (this.project.projektStatusKode > 3) {
                this.toggleSlider(true, asset)
            }
        },
        goToAssetDetailIcon (asset) {
            let match = asset.importMatch.find(i => i.ValgtAlternativ === 'J' && i.AktivId)
            if (match) {
                const keys = Object.keys(match)
                let key = null
                let n = keys.length
                let newObj = {}
                while (n--) {
                    key = keys[n]
                    const lowerKey = key.charAt(0).toLowerCase() + key.slice(1)
                    newObj[lowerKey] = match[key]
                }
                this.toggleSlider(true, newObj)
            } else {
                this.$notify({
                    group: 'info',
                    type: 'warn',
                    title: 'Aktivet har ingen detaljer'
                })
            }
        },
        deviation (item) {
            if (item.Afvigelse < 100 || item.Afvigelse === 100) {
                return 'arrow-down-right2'
            } else {
                return 'arrow-up-right2'
            }
        },
        async exportAsExcel () {
            try {
                const response = await axios.downloadExcel('/Value/Export/ExportProjekt ', {id: this.project.id, balanceId: this.selectedBalanceId})
                if (response) {
                    return new Promise((resolve, reject) => {
                        let blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob, 'Value_Projekt.xlsx')
                            resolve(blob)
                        }

                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob, 'Value_Projekt.xlsx')
                        link.download = 'Value_Projekt.xlsx'
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)

                        resolve(blob)
                    })
                }
            } catch (err) {
                throw err
            }
        },
        async save (handler) {
            try {
                if (!handler) {
                    this.projectHandlerHeader = 'Gemmer...'
                    this.projectHandlerModalConfig.open()
                }
                this.assets.forEach((asset, index) => {
                    let foundProject = null
                    if (this.project.projektStatusKode === 3) {
                        foundProject = this.project.importAktivs.find(aktiv => aktiv.id === asset.id)
                    } else {
                        foundProject = this.project.aktivs.find(aktiv => aktiv.id === asset.id)
                    }

                    foundProject.importInfo.forEach(info => {
                        info.Vaerdi = window.numeral(asset.restVaerdi).value()
                    })
                })

                await axios.post('/Value/Project/UpdateProject', {
                    importAktivs: this.project.importAktivs,
                    id: this.project.id,
                    projektNr: this.project.projektNr,
                    beskrivelse: this.project.beskrivelse,
                    projektVaerdi: this.newProjectValue,
                    navn: this.project.navn,
                    projektStatusKode: this.project.projektStatusKode
                })

                if (!handler) {
                    this.projectHandlerModalConfig.close()
                }
            } catch (err) {
                this.projectHandlerHeader = 'Der skete en fejl. Prøv igen'
                setTimeout(() => {
                    this.projectHandlerModalConfig.close()
                }, 2500)
                console.log('error saving project', err)
            }
        },
        async activate () {
            try {
                this.projectHandlerHeader = 'Aktiverer...'
                this.projectHandlerModalConfig.open()

                await this.save('activate')

                await axios.post('/Value/Project/ActivateProject', {
                    anlaegsProjektId: this.project.id,
                    regnskabId: this.selectedRegnskab.id
                })

                this.projectHandlerModalConfig.close()

                location.reload()
            } catch (err) {
                this.projectHandlerHeader = 'Der skete en fejl. Prøv igen'
                setTimeout(() => {
                    this.projectHandlerModalConfig.close()
                }, 2500)
                console.log('error activating project', err)
            }
        },
        async getPriceMeter (id, showModalConfig) {
            try {
                if (showModalConfig) {
                    this.projectHandlerHeader = 'Henter data...'
                    this.projectHandlerModalConfig.open()
                }
                const response = await axios.post('/Value/Setting/GetPrisMeter', {
                    aarsbalanceId: id || this.$store.getters.getSelectedBalance.aarsbalance.id
                })
                if (response) {
                    this.priceMeter = response.data
                    if (showModalConfig) {
                        this.projectHandlerModalConfig.close()
                    }
                }
            } catch (err) {
                this.projectHandlerHeader = 'Der skete en fejl. Prøv igen'
                setTimeout(() => {
                    this.projectHandlerModalConfig.close()
                }, 2500)
                throw err
            }
        },
        async getProject (showModalConfig) {
            try {
                if (showModalConfig) {
                    this.projectHandlerHeader = 'Henter projekt'
                    this.projectHandlerModalConfig.open()
                }
                const response = await axios.post('/Value/Project/ReadProjectDetailsById', {
                    id: this.$route.params.id,
                    balanceId: this.selectedBalanceId
                })
                if (response) {
                    this.project = response.data
                    this.newProjectValue = response.data.projektVaerdi
                    if (showModalConfig) {
                        this.projectHandlerModalConfig.close()
                    }
                }
            } catch (err) {
                if (showModalConfig) {
                    this.projectHandlerHeader = 'Der skete en fejl. Prøv igen'
                    setTimeout(() => {
                        this.projectHandlerModalConfig.close()
                    }, 2500)
                }
                console.log('error getting project', err)
            }
        },
        mapLoaded () {
            if (this.mapLayers.featureLayer && this.mapLayers.featureLayer.features.length > 0) {
                this.mapConfig.fit(this.mapLayers.featureLayer)
            } else {
                this.mapConfig.fit(new NMapBoundingBox(
                    new NMapCoordinates(8.08997684086, 54.8000145534, 'EPSG:4326'),
                    new NMapCoordinates(12.6900061378, 57.730016588, 'EPSG:4326')
                ))
            }
        },
        populateMap () {
            if (this.project.projektStatusKode === 3) {
                if (this.project.importAktivs && this.project.importAktivs.length > 0) {
                    this.mapLayers.featureLayer = new NMapLayerVector({
                        hidden: true
                    })
                    this.mapConfig.addLayer(this.mapLayers.featureLayer)
                    this.mapLayers.highlightLayer = new NMapLayerVector({
                        hidden: true
                    })
                    this.mapConfig.addLayer(this.mapLayers.highlightLayer)
                    this.project.importAktivs.forEach(aktiv => {
                        if (aktiv.wkt) {
                            const feature = new NMapFeature({
                                sourceType: 'wktGeometry',
                                source: aktiv.wkt,
                                projection: 'EPSG:25832',
                                style: this.getFeatureStyle(aktiv)
                            })
                            this.mapLayers.featureLayer.addFeature(feature)
                            aktiv.feature = feature
                        }
                    })
                }
            } else {
                if (this.project.aktivs && this.project.aktivs.length > 0) {
                    this.mapLayers.featureLayer = new NMapLayerVector({
                        hidden: true
                    })
                    this.mapConfig.addLayer(this.mapLayers.featureLayer)
                    this.mapLayers.highlightLayer = new NMapLayerVector({
                        hidden: true
                    })
                    this.mapConfig.addLayer(this.mapLayers.highlightLayer)
                    this.project.aktivs.forEach(aktiv => {
                        if (aktiv.wkt) {
                            const feature = new NMapFeature({
                                sourceType: 'wktGeometry',
                                source: aktiv.wkt,
                                projection: 'EPSG:25832',
                                style: this.getFeatureStyle(aktiv)
                            })
                            this.mapLayers.featureLayer.addFeature(feature)
                            aktiv.feature = feature
                        }
                    })
                }
            }
        },
        getFeatureStyle (item) {
            let style = new NMapStyle({
                strokeWidth: 2
            })
            switch (item.mapStyle) {
            case 'spild_spildevandsledning':
                style.strokeColor = 'red'
                break

            case 'spild_regnvandsledning':
                style.strokeColor = 'blue'
                style.strokeDash = [10, 10]
                break

            case 'spild_faellesledning':
                style.strokeColor = 'green'
                style.strokeDash = [25, 10]
                break

            case 'spild_draenledning':
                style.strokeColor = 'pink'
                style.strokeDash = [25, 10]
                break

            case 'spild_trykledning-spildevand':
                style.strokeColor = 'red'
                style.strokeDash = [20, 10, 6, 10]
                break

            case 'spild_trykledning-regnvand':
                style.strokeColor = 'blue'
                style.strokeDash = [20, 10, 6, 10]
                break

            case 'spild_nedlagtledning':
                style.strokeColor = 'yellow'
                style.strokeDash = [20, 10, 8, 10]
                break

            case 'spild_broend':
                style = new NMapStyleCircle({
                    fillOpacity: 0,
                    strokeColor: 'black'
                })
                break

            default:
                style.strokeColor = 'black'
                break
            }

            return style
        }
    },
    async created () {
        if (this.$route.params.id) {
            this.loading = true

            NMapUtils.registerProjection('EPSG:25832', '+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs')
            this.mapConfig = new NMapConfig()
            this.mapConfig.addButton(new NMapLayerControl({
                map: this.mapConfig
            }))
            this.mapConfig.addLayer(new NMapLayerOpenStreetMap())
            this.mapConfig.addLayer(new NMapLayerEsriWorldImagery({
                visible: false
            }))

            await this.getProject()

            let totalValue = 0
            let outgoing = 0
            let allImports = []

            if (this.project.projektStatusKode > 4) {
                if (this.project.aktivs && this.project.aktivs.length > 0) {
                    this.project.aktivs.forEach(aktiv => {
                        totalValue += aktiv.restVaerdi
                        allImports.push(aktiv)
                    })
                }
            } else {
                if (this.project.importAktivs && this.project.importAktivs.length > 0) {
                    this.project.importAktivs.forEach(aktiv => {
                        const selectedImportInfo = aktiv.importInfo.find(i => i.BalanceId.toLowerCase() === this.selectedBalanceId.toLowerCase())
                        if (selectedImportInfo) {
                            if (aktiv.afgang) {
                                outgoing += selectedImportInfo.Vaerdi
                            } else {
                                totalValue += selectedImportInfo.Vaerdi
                            }

                            this.$set(aktiv, 'levetid', selectedImportInfo.Levetid)
                            this.$set(aktiv, 'restVaerdi', parseFloat(selectedImportInfo.Vaerdi))
                            this.$set(aktiv, 'afskrivningStart', selectedImportInfo.AfskrivningStart)

                            if (this.checkImportType(aktiv)) { this.$set(aktiv, 'getvalue', false) } else { this.$set(aktiv, 'getvalue', true) }
                        } else {
                            aktiv.restVaerdi = 0
                        }

                        allImports.push(aktiv)
                    })
                }

                const currentBalanceYear = this.regnskabSetting.find(r => r.id === this.selectedBalanceId)
                if (currentBalanceYear) {
                    this.AfskrivningsStartDato = new Date(currentBalanceYear.aarsbalance.aar, 11, 31)
                }

                await this.getPriceMeter()
            }

            this.totalAssetsValue = totalValue
            this.outgoingAssetsValue = outgoing
            this.assets = allImports
            console.log('projekt.aktiver', allImports)
            this.populateMap()

            this.projectHandlerModalConfig = new ModalConfig({})
            this.projectNoteModalConfig = new ModalConfig({
                reject: 'Annuller',
                accept: 'Gem'
            })
            this.projectActivateModalConfig = new ModalConfig({
                reject: 'Annuller',
                accept: 'Aktivér'
            })

            this.loading = false
        }
    }
}
</script>

<style lang="scss" scoped>
.project-container {
    display: flex;
    flex-direction: column;

    .project-container-header {
        flex: 0 0 auto;
        justify-content: center;
        padding: 20px 0;
        background-color: #367abd;
        color: #fff;
        height: 160px;
        max-height: 160px;
        z-index: 999;

        .grid-x {
            height: 100%;
        }

        .flexbox-start {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        h3 {
            font-weight: 400;
            margin-bottom: 10px;

            span {
                margin-bottom: 10px;
                border-bottom: 1px solid #fff;
            }
        }
    }

    .project-container-main {
        flex: 1;
        display: flex;
        flex-direction: column;

        .small-cell {
            width: 4%;
        }

        .flex-column {
            display: flex;
            flex-direction: column;
        }

        .project-container-main-inner-top {
            flex: 0;

            h1 {
                margin-top: 15px;
            }

            .project-container-main-inner-top-row {
                display: flex;
                flex-direction: row;
                border-bottom: 1px solid #eee;

                .project-container-main-inner-top-row-left, .project-container-main-inner-top-row-right {
                    width: 100%;
                }

                .project-container-main-inner-top-row-left {
                    h6 {
                        text-align: end;
                    }

                    .project-container-main-inner-top-row-left-item {
                        display: flex;
                        flex-direction: row;
                        margin-bottom: 8px;

                        .align-text {
                            display: flex;
                            align-items: center;
                            width: 100%;
                        }

                        .project-value-input {
                            /deep/ input {
                                padding-right: 44px !important;
                                margin-bottom: 0px !important;
                            }
                        }

                        span {
                            width: 100%;
                        }

                        .project-assets-input {
                            width: 100%;
                            text-align: right;

                            span {
                                padding-right: 21px;
                                color: #82868d;
                            }
                        }
                    }
                }

                .project-container-main-inner-top-row-right {
                    display: flex;
                    flex-direction: row;

                    .project-container-main-inner-top-row-right-left {
                        display: flex;
                        flex-direction: column;
                        text-align: center;
                        width: 100%;

                        .project-container-main-inner-top-row-right-left-difference {
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            p {
                                font-weight: bold;
                                font-size: 1.5rem;
                                line-height: 1.4;
                                margin-top: 0;
                                margin-bottom: .5rem;
                                display: inline-block;
                            }
                        }
                    }

                    .project-container-main-inner-top-row-right-right {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                    }
                }
            }
        }

        .project-container-main-inner-balance {
            flex: 0;
            display: flex;
            align-items: center;
            padding-top: 10px;
            padding-bottom: 10px;

            .project-container-main-inner-balance-balance, .project-container-main-inner-balance-switch, .project-container-main-inner-balance-date {
                display: flex;
                width: 100%;
            }

            .project-container-main-inner-balance-balance {
                align-items: center;
            }

            .project-container-main-inner-balance-switch {
                align-items: center;
                justify-content: center;
            }
        }

        .project-container-main-inner-export {
            flex: 0;
            display: flex;
            align-items: center;

            div:first-of-type {
                display: flex;
                flex: 1;
            }
        }

        .project-container-main-inner-list {
            flex: 1 1 0;
            overflow-y: auto;

            .list-sort {
                padding-left: 0px;
                padding-right: 0px;
            }
        }
    }
}

.list-row {
    .cell {
        height: 100%;

        &.large-4 {
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        &.button-highlight {
            margin-top: 11px;
        }
    }
}

.list-row:hover {
    .truncate-fade-blue:after {
        background: linear-gradient(to right, rgba(255, 255, 255, 0), #e5eff2 71%) !important;
    }
}

.padding-right-20 {
    padding-right: 20px;
}

.button-highlight {
    border: 1px solid #eee;
    margin-right: 6px;
    margin-top: 4px;
    transition: .3s all ease;
    background-color: #fff;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);

    &:hover {
        background-color: #367ABD;
        border-color: #367ABD;

        svg {
            fill: #fff;
        }
    }
}

.icon-button {
    border: 2px solid rgb(247, 247, 247);
    transition: .3s all ease;
    background-color: #fff;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3px;
    cursor: pointer;

    &:hover {
        border-color: #367ABD;
    }
}

.active-button {
    &.disabled {
        pointer-events: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/project.vue